<template>
  <div class="chat-issue-item" v-if="questions.length > 0">
    <div class="message-wrapper">
      <div class="conversation-message">
        <el-skeleton
          style="width: 100%"
          :loading="showSkeleton"
          animated
          :throttle="{ leading: 500, trailing: 500, initVal: true }"
          v-if="isAnimation"
        >
          <template #template>
            <!-- <el-skeleton-item variant="image" style="width: 240px; height: 265px" /> -->
            <div style="display: flex; flex-direction: column; width: 100%;">
              <el-skeleton-item variant="text" v-for="(item, index) in questions" style="width: 100%; height: 15px; margin-top: 10px;" />
            </div>
          </template>
          <template #default>
            <div style="display: flex; flex-direction: column;">
              <div class="messageItem" v-for="(item, index) in questions">
                <span class="message-title">{{item}}</span>
              </div>
            </div>
          </template>
        </el-skeleton>
        <div style="display: flex; flex-direction: column;" v-if="!isAnimation">
          <div class="messageItem" v-for="(item, index) in questions" @click="(()=>{resetSendQusition(item)})">
            <span class="message-title">{{item}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";

let call = defineEmits(["issueFinish", "resetSendQusition"])

interface Props {
  questions: string[]
  isAnimation: boolean
}
const props = defineProps<Props>()
const showSkeleton = ref(true)

function showIssueItem () {
  setTimeout(()=>{
    showSkeleton.value = false
    call("issueFinish")
  },3000)
}

function resetSendQusition(content) {
  call("resetSendQusition", {content: content})
}

onMounted(()=>{
  if(props.isAnimation) {
    showIssueItem()
  }
  call("issueFinish")
})

</script>

<style lang="less">
.chat-issue-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  .message-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 4px;
    margin-bottom: 4px;
    position: relative;
    max-width: 100%;
    border-radius: 10px 10px 10px 10px;
    .conversation-message {
      border-radius: 8px;
      // padding: 10px 12px;
      font-size: 14px;
      overflow-wrap: break-word;
      box-sizing: border-box;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      width: 100%;
      .messageItem {
        width: auto; /* 宽度自适应 */
        margin-top: 10px;
        max-width: 100%;
      }
      .message-title {
        color: #2590E1;
        font-size: 14px;
        line-height: 20px;
        border-bottom: transparent 1px solid;
        cursor: pointer;
        &:hover {
          border-bottom: #2590E1 1px solid;
        }
      }
    }
  }
}
</style>
